module.exports = __webpack_public_path__ + "assets/img/nogrid-logo-small.df97d505.png";